module.exports = __webpack_public_path__ + "static/media/3dots.08ead5a8.svg";